"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const Actor = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  d: "M7.331 6.327c.216.047.44.073.669.073.23 0 .454-.026.67-.073l2.036 4.074A3.186 3.186 0 009.714 12H6.286a3.186 3.186 0 00-.99-1.6L7.33 6.328zM12.8 9.6c-.23 0-.453.026-.669.074L10.095 5.6A3.18 3.18 0 0011.2 3.2C11.2 1.436 9.765 0 8 0a3.204 3.204 0 00-3.2 3.2c0 .96.434 1.813 1.106 2.4L3.87 9.674A3.128 3.128 0 003.2 9.6 3.204 3.204 0 000 12.8C0 14.565 1.436 16 3.2 16a3.197 3.197 0 003.086-2.4h3.428A3.196 3.196 0 0012.8 16c1.765 0 3.2-1.435 3.2-3.2 0-1.764-1.435-3.2-3.2-3.2z"
}));
var _default = exports.default = Actor;